import React from 'react';
import { ReactComponent as TriggerXRay } from 'assets/trigger-x-ray.svg';
import css from './ShopifyBilling.module.css';

export const SuperCapturePixelInfo = () => (
  <div className={css.supercapture}>
    <TriggerXRay />

    <span className={css.bold}>SUPER CAPTURE PIXEL Capture 15% more leads</span>
  </div>
);
